export const cardsFilterTypes = {
  'DEVICETYPE': 'deviceType',
  'DATATYPE': 'dataType',
  'CARDTYPE': 'cardType'
}

export const moduleId = 'cards'